import { Assets } from 'pixi.js'
export let language = 'EN'
export async function initLanguage(param: string | null, isManualLoaded = true, gameSupportLanguages: string[] = ['EN', 'TH_TH', 'JA_JP']) {
  const languageKey = 'slot_language'

  if (param !== null) {
    language = param.toUpperCase()
  }
  else {
    const stored = window.sessionStorage.getItem(languageKey)
    if (stored !== null) {
      language = stored
    }
  }

  // check supportedLanguages
  if (!gameSupportLanguages.includes(language)) {
    language = 'EN'
  }
  window.sessionStorage.setItem(languageKey, language)

  if (isManualLoaded) {
    // not use AssetPack
    await Assets.load({
      alias: language,
      src: `${import.meta.env.BASE_URL}/resource/locales/${language}.json`,
    })
  }
}
export function t(key: string) {
  const localizationString = Assets.get(language)[key]
  if (localizationString === undefined) {
    console.warn(`Key ${key} not found in locale`)
    return key
  }
  return localizationString as string
}
